// extracted by mini-css-extract-plugin
export default {"box":"ToDo_box__hFhdL","boxChild":"ToDo_boxChild__Y1b43","buttonSection":"ToDo_buttonSection__DLBgo","taskList":"ToDo_taskList__LuDkp","taskHandle":"ToDo_taskHandle__V+ZxR"};